const WATCHVIM_BLOB_HOST = 't6ht6kdwnezp05ut.public.blob.vercel-storage.com';

export function mediaUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  try {
    const absolute = raw.startsWith('//') ? `https:${raw}` : raw;
    const url = new URL(absolute, typeof window === 'undefined' ? 'https://watchvim.com' : window.location.origin);
    if (url.hostname === WATCHVIM_BLOB_HOST) {
      return `/media/blob${url.pathname}${url.search}`;
    }
    return absolute;
  } catch (_) {
    return raw;
  }
}

export const WATCHVIM_LOGO_URL = '/brand/watchvim-logo.png';
export const VIM_MEDIA_LOGO_URL = '/brand/vim-media-logo-gold.png?v=20261002';
export const VIM_MEDIA_MONOGRAM_URL = '/brand/vim-media-monogram-gold.png';
